import { makeObservable } from 'mobx';

class Keyframe {
  private id: string;

  private regionInfo: CF.API.RegionInfo;

  private concept: CF.API.Concept;

  private time: number;

  constructor(id: string, regionInfo: CF.API.RegionInfo, concept: CF.API.Concept, time: number) {
    this.id = id;
    this.regionInfo = regionInfo;
    this.concept = concept;
    this.time = time;

    makeObservable(this);
  }

  public getId() {
    return this.id;
  }

  public getRegionInfo() {
    return this.regionInfo;
  }

  public setRegionInfo(regionInfo: CF.API.RegionInfo) {
    this.regionInfo = regionInfo;
  }

  public getConcept() {
    return this.concept;
  }

  public setConcept(concept: CF.API.Concept) {
    this.concept = concept;
  }

  public getTime() {
    return this.time;
  }

  public setTime(time: number) {
    this.time = time;
  }
}

export { Keyframe };
